import type { SessionChipOption } from '@/components/SessionAttendanceChips/types';

export interface SessionSelectionSummary {
  isAllSelected: boolean;
  label: string;
}

// Shared "All sessions" / "N of M sessions" badge text -- shown next to the
// Sessions section title in the booking modal.
export const getSessionSelectionSummary = (
  selectedIds: string[],
  sessions: SessionChipOption[]
): SessionSelectionSummary => {
  const isAllSelected = sessions.length > 0 && selectedIds.length === sessions.length;
  return {
    isAllSelected,
    label: isAllSelected ? 'All sessions' : `${selectedIds.length} of ${sessions.length} sessions`
  };
};
